import { ObjectMapper } from "json-object-mapper";
import { BenefitType, BenefitTypeEnum } from "services/enums/benefitsType.enum";
import { IModel } from "../IModel";
import { Model } from "../model";
import { PetitionsRequestType } from "services/enums/petitionsRequestType.enum";

export class BenefitsAvailablesModel
	extends Model
	implements IModel<BenefitsAvailablesModel> {
	benefitEmployeeId: string | undefined = undefined;
	benefitOfferedId: string | undefined = undefined;
	benefitType: BenefitType = "MealVoucher";
	description: string = "";
	entryMode: string = "";
	logo: string = "";
	name: string = "";
	petitionId: string | undefined = undefined;
	providerId: string | undefined = undefined;
	requestType: PetitionsRequestType = "ACCESSION";

	get benefitTypeLabel(): string {
		return BenefitTypeEnum.getBy(this.benefitType).label;
	}

	static create(input: any): BenefitsAvailablesModel {
		return ObjectMapper.deserialize<BenefitsAvailablesModel>(
			BenefitsAvailablesModel,
			input
		);
	}

	public toJSON(): string {
		return ObjectMapper.serialize(this) as string;
	}
}
